import Vue from 'vue'
import App from '@/app/App.vue'
import router from '@/router'
import store from '@/store'
// import './registerServiceWorker'
import '@babel/polyfill'

// plugins
import vuetify from '@/plugins/vuetify'
import LayoutEmpty from '@/layouts/empty'
import LayoutDefault from '@/layouts/default'

import '@/plugins/axios'

Vue.component('empty-layout', LayoutEmpty)
Vue.component('default-layout', LayoutDefault)

// Style
import '@/style/style.scss'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
